<nav [class.scrolled]="isScrolled">
  <a class="nav-logo" routerLink="/">
    <img class="nav-logo-img" [src]="logoSrc" alt="Pilates by Elisah" />
    <div class="nav-logo-text">
      <span class="top">Pilates</span>
      <span class="sub">by Elisah</span>
    </div>
  </a>

  <button class="nav-toggle" (click)="isMenuOpen = !isMenuOpen" [class.open]="isMenuOpen" aria-label="Menu">
    <span></span><span></span><span></span>
  </button>

  <ul class="nav-links" [class.open]="isMenuOpen" (click)="isMenuOpen = false">
    <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Home</a></li>
    <li><a routerLink="/about" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Wie ben ik</a></li>
    <li><a routerLink="/classes" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Pilates</a></li>
    <!--<li><a routerLink="/target-audience" (routerLinkActive)="isActive('/')">Voor wie</a></li>-->
    <li><a routerLink="/offer" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Lessen en tarieven</a></li>
    <li><a routerLink="/calendar" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Agenda</a></li>
    @if (isLoggedIn) {
      <li class="nav-basket-item"
          (mouseenter)="openBasketPreview()" (mouseleave)="closeBasketPreview()"
          (focusin)="openBasketPreview()" (focusout)="closeBasketPreview()">
        <a routerLink="/checkout" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-basket"
           aria-label="Winkelmandje" aria-haspopup="true" [attr.aria-expanded]="isBasketOpen">
          🧺
          @if (basketCount > 0) { <span class="nav-basket-badge">{{ basketCount }}</span> }
        </a>

        @if (isBasketOpen) {
          <div class="basket-preview" role="dialog" aria-label="Winkelmandje overzicht">
            <span class="basket-preview-title">Winkelmandje</span>

            @if (hasBasketLines) {
              @if (basketItems.length > 0) {
                <ul class="basket-preview-list">
                  @for (item of basketItems; track item.id) {
                    <li class="basket-preview-row">
                      <span class="basket-preview-info">
                        <span class="basket-preview-name">{{ item.className }}</span>
                        <span class="basket-preview-meta">
                          {{ formatService.formatDate(item.classDate) }} · {{ formatService.formatTime(item.classTime) }}
                          @if (item.coveredByVoucherBeingBought) { <span class="basket-preview-badge">Inbegrepen</span> }
                          @else if (item.coveredByVoucher) { <span class="basket-preview-badge">Beurtenkaart</span> }
                          @else if (item.partlyCoveredByVoucher) { <span class="basket-preview-badge">Deels beurtenkaart</span> }
                        </span>
                      </span>
                      @if (item.coveredByVoucher || item.partlyCoveredByVoucher || item.coveredByVoucherBeingBought) {
                        <span class="basket-preview-price basket-preview-price--covered">
                          <s>€ {{ formatService.formatPrice(item.voucherPrice) }}</s> € {{ formatService.formatPrice(item.amountPayable) }}
                        </span>
                      } @else {
                        <span class="basket-preview-price">€ {{ formatService.formatPrice(item.price) }}</span>
                      }
                    </li>
                  }
                </ul>
              }

              @if (voucherItems.length > 0) {
                <ul class="basket-preview-list basket-preview-list--vouchers">
                  @for (voucher of voucherItems; track voucher.id) {
                    <li class="basket-preview-row">
                      <span class="basket-preview-info">
                        <span class="basket-preview-name">{{ voucher.quantity }} × {{ voucher.name }}</span>
                        <span class="basket-preview-meta">{{ voucher.lessonsTotal }} lessen · € {{ formatService.formatPrice(voucher.unitPrice) }} per kaart</span>
                      </span>
                      <span class="basket-preview-price">€ {{ formatService.formatPrice(voucher.total) }}</span>
                    </li>
                  }
                </ul>
              }

              <div class="basket-preview-total">
                <span>Totaal</span>
                <span class="basket-preview-total-amount">€ {{ formatService.formatPrice(basketTotal) }}</span>
              </div>
            } @else if (ownedVouchers.length === 0) {
              <p class="basket-preview-empty">Je winkelmandje is nog leeg.</p>
            }

            @if (ownedVouchers.length > 0) {
              <span class="basket-preview-subtitle">Je beurtenkaarten</span>
              <ul class="basket-preview-list">
                @for (voucher of ownedVouchers; track voucher.id) {
                  <li class="basket-preview-row">
                    <span class="basket-preview-info">
                      <span class="basket-preview-name">{{ voucher.name }}</span>
                      <span class="basket-preview-meta">{{ voucher.code }} · nog {{ voucher.lessonsRemaining }} lessen</span>
                    </span>
                    <span class="basket-preview-price basket-preview-price--owned">€ {{ formatService.formatPrice(voucher.remainingAmount) }}</span>
                  </li>
                }
              </ul>
            }
            @if (isLoggedIn && !isCheckoutPage) {
            <a routerLink="/checkout" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="basket-preview-cta">Naar afrekenen</a>
            }
          </div>
        }
      </li>

      <li class="nav-user-item"
          (mouseenter)="openUserMenu()" (mouseleave)="closeUserMenu()"
          (focusin)="openUserMenu()" (focusout)="closeUserMenu()">
        <button type="button" class="nav-user" (click)="openUserMenu()"
                aria-haspopup="true" [attr.aria-expanded]="isUserOpen">
          <svg class="nav-user-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="1.5" aria-hidden="true">
            <circle cx="12" cy="8" r="3.5" />
            <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" stroke-linecap="round" />
          </svg>
          <span class="nav-user-name">{{ userName }}</span>
        </button>

        <div class="user-menu" [class.open]="isUserOpen">
          @if (hasRole('ADMIN')) {
          <button type="button" class="user-menu-logout" (click)="openAdmin()">Administratie</button>
          }
          @if (hasRole('CUSTOMER')) {
          <button type="button" class="user-menu-logout" (click)="openCustomerOverview()">overzicht aankopen</button>
          }
          <button type="button" class="user-menu-logout" (click)="logout()">Afmelden</button>
        </div>
      </li>
    }
  </ul>
</nav>